// HKDSE Type A (議論散文) Q&A Data
// A1. 孟子《魚我所欲也》
// A2. 荀子《勸學》（節錄）
// A3. 蘇洵《六國論》
// A4. 莊子《逍遙遊》
// A5. 韓愈《師說》

export const hkdseTypeAQAData = {
  'hkdse-a1-mengzi-fish': {
    title: '孟子《魚我所欲也》問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落結構與論證方法',
        content: [
          {
            subtitle: '第一段：對比論證',
            points: [
              {
                title: '內容重點',
                items: [
                  '以「魚與熊掌」比喻「生與義」，指出當兩者不可兼得時，應捨生取義。',
                  '以正反論證方式，說明義比生命更重要，並非只有賢者才有此本心，人人皆有，只是賢者能堅持不失。'
                ]
              },
              {
                title: '論證手法',
                items: [
                  '對比：「魚與熊掌」vs「生與義」',
                  '比喻：將抽象的生與義，用具體的魚與熊掌比較，令道理更易明白。',
                  '正反立論：分別從選擇生或義的角度推論。'
                ]
              }
            ]
          },
          {
            subtitle: '第二段：舉例論證',
            points: [
              {
                title: '內容重點',
                items: [
                  '以「行道之人」及「乞丐」拒絕受辱的食物為例，說明即使在生死關頭，人都有固守本心、堅持禮義的情操。'
                ]
              },
              {
                title: '論證手法',
                items: [
                  '舉例：「一簞食，一豆羹，得之則生，弗得則死……」',
                  '對照：乞丐尚且不屈，諷刺有些人為名利而失義。'
                ]
              }
            ]
          },
          {
            subtitle: '第三段：分析本心',
            points: [
              {
                title: '內容重點',
                items: [
                  '指出「捨生取義」是人生的根本選擇，本心即人與生俱來的羞惡之心，任何人本都有，只是有些人因物慾而迷失本心。'
                ]
              },
              {
                title: '論證手法',
                items: [
                  '分析及說明：義比生命更可貴，揭示社會風氣敗壞的原因。'
                ]
              }
            ]
          },
          {
            subtitle: '第四段：說明本心的重要',
            points: [
              {
                title: '內容重點',
                items: [
                  '強調失去本心會導致見利忘義，喪失人性，呼籲人們應堅守本心，不應為外在利益放棄原則。'
                ]
              }
            ]
          }
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '試根據篇章內容，解釋作者在文中以魚和熊掌分別比喻生和義的目的。（3分）',
            answer: '作者以魚和熊掌作比喻，是將抽象的「生」與「義」轉化為具體可見的選擇，讓讀者更容易明白當兩者無法兼得時，應該選擇價值較高者。這個比喻說明了當面對生與義的抉擇時，應如選擇熊掌般，優先取義而捨生，突出義的重要性。'
          },
          {
            question: '試解釋「由是則可以辟患而有不為也，由是則可以得生而有不用也」的意思。（2分）',
            answer: '這句話意思是：憑這些方法可以躲避禍患，有人卻不去做；憑這些方法可以獲得生存，有人卻不願意採用。這說明有些事情雖然能免災避禍或保全生命，但因為違背本心或道義，人們會選擇不為之。'
          },
          {
            question: '作者在文中如何運用反問和排比句強化論點？（2分）',
            answer: '作者運用了多個反問句，如「如使人之所欲莫甚於生，則凡可以得生者，何不用也？」引導讀者思考生命與道義的取捨。同時，文中亦運用排比句，如「鄉為身死而不受，今為宮室之美為之……」，強調昔日和今日的對比，突顯失本心的可悲，進一步強化「捨生取義」的中心思想。'
          },
          {
            question: '作者以乞丐拒受羞辱食物的例子想說明甚麼道理？（2分）',
            answer: '乞丐雖然生活困苦，面臨生死，但依然不願接受帶有羞辱性的施捨，說明即使在極端困境下，人亦有堅守禮義、不苟且偷生的本心，進一步證明「捨生取義」並非賢者專有，人人皆有。'
          },
          {
            question: '簡述《魚我所欲也》的體裁及作者如何陳述觀點。（4分）',
            answer: '《魚我所欲也》屬語錄體。作者首先以具體比喻引出主旨，接著論證「捨生取義」的道理，並舉例支持觀點，運用反問、排比、對比等修辭手法層層遞進說理，最後歸納論點，論證嚴密，層次分明，具說服力。'
          }
        ]
      }
    }
  },
  'hkdse-a2-xunzi-learning': {
    title: '荀子《勸學》（節錄）問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落結構與重點',
        content: [
          {
            subtitle: '第一段：學習的作用及意義',
            points: [
              {
                title: '主旨',
                items: ['說明學習能改變人的本性，提升修養。']
              },
              {
                title: '論證手法',
                items: [
                  '對比：「終日而思矣，不如須臾之所學也」——用整天思考與片刻學習比較，突顯學習的效益。',
                  '比喻：「青出於藍而青於藍」「冰，水為之而寒於水」——說明後天學習可以超越先天本性。'
                ]
              },
              {
                title: '結論',
                items: ['學習要專心致志，持之以恆，才能積累成大成就。']
              }
            ]
          },
          {
            subtitle: '第二段：學習的方法與態度',
            points: [
              {
                title: '主旨',
                items: ['強調學習要懂得借助外在資源，發揮外物的力量，並非全靠天分。']
              },
              {
                title: '論證手法',
                items: [
                  '對比：「登高而招，臂非加長也，而見者遠。」、「順風而呼，聲非加疾也，而聞者彰。」',
                  '比喻：「假舟楫者，非能水也，而絕江河」——說明只要懂得善用外力，即使資質普通，也能有大成就。'
                ]
              },
              {
                title: '結論',
                items: ['君子與普通人無異，關鍵在「善假於物」。']
              }
            ]
          },
          {
            subtitle: '第三段：學習的持續與專注',
            points: [
              {
                title: '主旨',
                items: ['強調學習需持之以恆、專心一致，切忌半途而廢或三心兩意。']
              },
              {
                title: '論證手法',
                items: [
                  '對比：「騏驥一躍，不能十步；駑馬十駕，功在不舍。」',
                  '比喻：「積土成山，風雨興焉；積水成淵，蛟龍生焉。」——積少成多，日積月累才能成才。',
                  '象徵：「螾無爪牙之利，筋骨之強，上食埃土，下飲黃泉，用心一也。蟹六跪而二螯，非蛇蟺之穴無可寄託者，用心躁也。」——比喻專心致志與心浮氣躁的分別。'
                ]
              }
            ]
          }
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '文言實詞應用：根據《荀子‧勸學》一文，解釋「君子曰：學不可以已」的意思。',
            answer: '「學不可以已」意思是學習不能中斷，要不斷努力，持之以恆，才能有所得。'
          },
          {
            question: '本文的中心論點是什麼？',
            answer: '本文中心論點是：學習不能中止，只有持之以恆，懂得善用外物與專心致志，才能成就賢德。'
          },
          {
            question: '作者以哪些比喻說明學習能改變本性？',
            answer: '作者以「青出於藍而青於藍」、「冰水為之而寒於水」作比喻，說明學習能令人成績超越本性，甚至比原來更優秀。'
          },
          {
            question: '以「積土成山，積水成淵」為例，說明學習應有的態度。',
            answer: '「積土成山」及「積水成淵」比喻學習應持之以恆，點滴累積，才能最終成就大業，達到理想目標。'
          },
          {
            question: '本文為何常引用「君子曰」開首？有何作用？',
            answer: '常以「君子曰」作開首，是引用賢者的話來提出論點，加強說服力及權威感，令人信服。'
          },
          {
            question: '文章如何運用對比和比喻說明學習須持之以恆？',
            answer: '例如：「騏驥一躍，不能十步；駑馬十駕，功在不舍。」比喻即使資質一般，只要不放棄，亦能走得更遠；又如「鍥而舍之，朽木不折；鍥而不舍，金石可鏤」，說明學習要有恆心毅力，才能有所成就。'
          },
          {
            question: '根據文意，學習的成效取決於甚麼？',
            answer: '學習成效主要取決於持之以恆的毅力、專心一致的態度，以及懂得善用外物的能力，而非僅靠天賦。'
          }
        ]
      }
    }
  },
  'hkdse-a3-suxun-sixstates': {
    title: '蘇洵《六國論》問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '第四段：中心論點',
            points: [
              {
                title: '內容重點',
                items: [
                  '文章開首即提出「六國破滅，非兵不利，戰不善，弊在賄秦」——直截了當點明中心論點，強調六國滅亡的主因不在軍力或戰術，而是賄賂秦國，導致國力削弱、失去援助，最終滅亡。',
                  '作者開門見山提出論點，統領全文，讓讀者一開始就掌握文章主旨，下文再層層展開論證，結構嚴謹，脈絡清晰。'
                ]
              }
            ]
          },
          {
            subtitle: '第五段：章句及國家優劣比較',
            points: [
              {
                title: '內容重點',
                items: [
                  '蘇洵詳細比較六國與秦國的優劣：秦國雖強，但其他六國若能善用人才、團結一致，仍有機會抗衡強秦。',
                  '秦國「小則獲邑，大則得城」，六國卻割地賄秦，「以地事秦，猶抱薪救火」，只會助長秦國野心，最終自取滅亡。',
                  '六國祖先辛苦開疆拓土，子孫卻輕易割讓，結果國家益發衰弱，敵人愈加強大，最終滅亡。',
                  '結論：如果六國能善用人才、團結對外，或許能改變歷史命運，這也是蘇洵「借古諷今」的用意。'
                ]
              }
            ]
          }
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '本文主旨是什麼？（3分）',
            answer: '本文指出六國相繼滅亡，主要原因在於賄賂秦國，導致國力削弱、失去援助，最終滅亡。蘇洵藉此勸誡統治者應以史為鑑，善用人才，堅決對抗外敵，切勿重蹈六國割地求和、最終滅亡的覆轍。'
          },
          {
            question: '面對敵國入侵，作者認為當政者應採取什麼對策？為什麼？（3分）',
            answer: '蘇洵認為國家對內要善用人才，對外則應與友邦聯合抗敵，而非割地求和。因為割地只能暫時求安，反而削弱自身實力，助長敵人野心，終致滅亡。'
          },
          {
            question: '作者強調與外國交往時應注意什麼？（4分）',
            answer: '作者強調面對強敵，不應畏懼退縮，更不可輕易割地求和。應廣納賢才，團結友邦，提升國力，才能有效防禦外敵，確保國家安全。'
          },
          {
            question: '分析本文如何借古諷今？（3分）',
            answer: '本文以六國賂秦而亡為例，暗諷當時北宋割地求和的政策，提醒當權者要以史為鑑、改弦更張。蘇洵列舉史實、設例分析，既不直接指責朝政，又能達到警世目的。'
          },
          {
            question: '「以地事秦，猶抱薪救火，薪不盡，火不滅」這句話用了什麼論證手法？有何作用？',
            answer: '這句話運用了比喻論證和引用論證。比喻以「抱薪救火」形象地說明割地求和只會助長敵人野心，最終自取滅亡。引用古人之語，增強說服力，使道理更深刻易明。'
          },
          {
            question: '文章開首直接提出中心論點有何效果？（1分）',
            answer: '開門見山提出中心論點，讓全文結構嚴謹，論證有序，讀者一開始就能把握主旨，強化文章說服力，統領全文。'
          }
        ]
      }
    }
  },
  'hkdse-a4-zhuangzi-freedom': {
    title: '莊子《逍遙遊》問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '第一段：無用之用的哲理',
            points: [
              {
                title: '內容重點',
                items: [
                  '莊子運用比喻（如樗樹不中繩墨、不合規矩，不能做成一般有用之物），說明世人以實用為標準，認為「不中用」即「無用」。',
                  '惠子認為大樹無用，是因為它的形狀不合木匠要求，不能製作工具。',
                  '莊子則以狸狌（小動物，靈巧靈敏，卻容易被機關所困）和斄牛（體型巨大，雖不靈巧，卻能保全性命）作比喻，反駁惠子的觀點，說明「無用」反而能避禍，保存自身。',
                  '樗樹因無用而免於被砍伐，反而得以長存，這正是「無用之用」的體現。'
                ]
              }
            ]
          },
          {
            subtitle: '第二段：跳出功利的框架',
            points: [
              {
                title: '內容重點',
                items: [
                  '世人容易被外物和功利觀念所束縛，只重視事物的特定用途，忽略其潛在價值。',
                  '莊子指出，應放下執著，突破固有思維，懂得因材施用，才能發揮「大用」。',
                  '例如大瓠（大葫蘆）可以作為腰舟浮游江湖、擁有遼闊的自由，而不必拘泥於傳統用法。',
                  '不同的使用方法會產生不同的效果，正如不龜手藥方，既可漂洗棉絮，也能封賞建功。'
                ]
              }
            ]
          }
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '惠子為何認為樗樹無用？',
            answer: '因為樗樹的樹幹不中繩墨，枝條不合規矩，無法製作成有用的東西，故被認為無用。'
          },
          {
            question: '莊子是如何回應惠子的？',
            answer: '莊子以狸狌和斄牛作比喻：狸狌雖小而靈敏，但容易被捕捉；斄牛雖大而笨拙，卻能保全性命。又以樗樹因無用而免於砍伐為例，說明「無用」反而能長存，體現「無用之用」的道理。'
          },
          {
            question: '本文主要闡述什麼道理？',
            answer: '本文闡述「無用之用」的哲理，說明表面看似無用的事物，往往有更大的生存價值和作用，不應只從功利角度判斷有無用。'
          },
          {
            question: '文中有哪些容易理解的例子？',
            answer: '樗樹：因無用而免於被砍伐。大瓠：可作為腰舟，浮游於江湖。不龜手藥方：既可用於漂洗絲絮，也能用於立功受賞。'
          },
          {
            question: '莊子認為應如何轉變思想？',
            answer: '應放下功利執著，突破傳統框架，懂得變通，才能發揮事物潛在的大用，達到精神上的自由逍遙。'
          },
          {
            question: '莊子如何運用比喻說理？',
            answer: '莊子用狸狌與斄牛、樗樹、大瓠等比喻，對比不同的生存方式和用法，說明「無用」反而可能帶來大用，啟發讀者多角度思考事物價值。'
          },
          {
            question: '「有違之心」在文中有何具體表現？',
            answer: '指執著於事物表面用途，思維受到外在規範和功利觀念的束縛，不能發現事物潛在的價值。'
          },
          {
            question: '你同意莊子「無用之用，方為大用」的觀點嗎？請簡述你的看法。',
            answer: '同意。只追求「有用」會限制思維和發展，懂得欣賞和發揮「無用」的潛力，才能真正達到自由、無拘無束的境界。'
          }
        ]
      }
    }
  },
  'hkdse-a5-hanyu-teacher': {
    title: '韓愈《師說》問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '第七段重點整理',
            points: [
              {
                title: '強調從師的重要性',
                items: [
                  '以孔子及歷代賢人為例說明「聖人無常師」，孔子拜郯子、萇弘、師襄、老聃為師，即使這些人的賢能不及孔子，孔子依然虛心學習。'
                ]
              },
              {
                title: '論述學習態度',
                items: [
                  '指出學習應向不同的人請教，不應只向自認比自己強的人學習，因為「術業有專攻」，人人各有所長，皆有值得學習之處。'
                ]
              },
              {
                title: '以李氏子蟠為例',
                items: [
                  '李蟠年少好學，不拘於時，願意向作者學習，作者藉此肯定其尊師重道的精神，並重申從師學道的重要。'
                ]
              }
            ]
          }
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '本文的體裁及寫作動機是什麼？（3分）',
            answer: '本文屬於論說文。作者撰文是為了表達對師道不復的感慨，批評當時社會恥於從師的風氣。文中明確指出老師的職責是「傳道、受業、解惑」：即傳授道理、教授知識和解答學生的疑難。'
          },
          {
            question: '你認為「傳道、受業、解惑」三者中哪一項最重要？試陳述你的見解。（2分）',
            answer: '我認為「傳道」最重要。老師不只是傳授知識，更重要的是教導學生做人的道理和正確的價值觀。傳授知識雖然重要，但做人處事的道理更為根本。'
          },
          {
            question: '作者批評時人為何不願向年輕人學習？（3分）',
            answer: '作者認為，時人受社會成見影響，認為年輕人不足為師，忽視了學問與年齡無關，只要懂得道理就值得學習。老師的本質是「道之所存，師之所存」，而非僅以年資、地位為標準。'
          },
          {
            question: '作者如何對比說明古今之人的分別？（2分）',
            answer: '作者以古之聖人尚且從師學問為例，對比現今士大夫反以從師為恥，指出古人因從師而聖，今人因不從師而愚，突顯從師學習的重要。'
          },
          {
            question: '根據本文，為何現今士大夫不願從師？（3分）',
            answer: '現今士大夫認為向地位卑微的人學習會覺得羞恥，向地位高的人學習則被認為是拍馬屁，因此普遍不願從師，結果反而見識不如工匠、巫醫等行業的人。'
          },
          {
            question: '作者認為老師應具備怎樣的人格條件？（1分）',
            answer: '老師應具備「道之所存，師之所存」的精神，即只要懂得道理，無論年齡、地位高低，都值得為師。'
          },
          {
            question: '文中運用了哪些對偶句式？效果如何？請舉兩例說明。（3分）',
            answer: '對偶句式句構整齊，音韻和諧，使文章更具節奏感。例如：「聞道有先後，術業有專攻」、「位卑則足羞，官盛則近諛」。這些句子使內容更有層次感，增強語言表達力。'
          }
        ]
      }
    }
  }
};

export const getTypeAQAByTextId = (textId) => {
  return hkdseTypeAQAData[textId] || null;
}; 